import { render, staticRenderFns } from "./AppSider.vue?vue&type=template&id=bb58955a&"
import script from "./AppSider.vue?vue&type=script&lang=js&"
export * from "./AppSider.vue?vue&type=script&lang=js&"
import style0 from "./AppSider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports